import { collection, getDocs } from 'firebase/firestore'
import { z } from 'zod'
import { firestore, iamAuth } from '@/lib/firebase'

/**
 * Read-only mirror of iOS `PlaidItemSummary` — exposes just the fields
 * the Settings list actually renders so the backend can keep adding
 * other fields (cursor, accessToken, etc.) without breaking us.
 */

export const PlaidItemSummarySchema = z.object({
  itemId: z.string(),
  institutionName: z.string().default('Unknown institution'),
  institutionLogo: z.string().nullable().optional(),
  status: z.string().default('active'),
  lastSyncedAt: z.number().nullable().optional(),
})
export type PlaidItemSummary = z.infer<typeof PlaidItemSummarySchema>

export async function fetchPlaidItems(): Promise<PlaidItemSummary[]> {
  const uid = iamAuth.currentUser?.uid
  if (!uid) throw new Error('Not signed in')
  const snap = await getDocs(collection(firestore, 'users', uid, 'plaid_items'))
  const out: PlaidItemSummary[] = []
  for (const d of snap.docs) {
    const parsed = PlaidItemSummarySchema.safeParse(d.data())
    if (parsed.success) out.push(parsed.data)
    // Soft-skip docs that don't parse — partial data shouldn't lock
    // the user out of the rest of their items.
  }
  return out.sort((a, b) => a.institutionName.localeCompare(b.institutionName))
}
